import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HashRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import configureCustomerAuthStore from "./store/customerStore/auth-store";
import configureShoppingBasketStore from "./store/customerStore/shopping-basket-store";
import "react-toastify/dist/ReactToastify.css";
import { LanguageProvider } from "./store/language-context";
import { HelmetProvider } from "react-helmet-async";
import ErrorBoundary from "./pages/DefaultPages/ErrorBoundary/ErrorBoundary";

configureCustomerAuthStore();
configureShoppingBasketStore();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <ErrorBoundary> */}
    <HashRouter>
      <LanguageProvider>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </LanguageProvider>
      <ToastContainer theme="colored" />
    </HashRouter>
    {/* </ErrorBoundary> */}
  </React.StrictMode>,
);
